import React from "react"
import {Link} from "gatsby";
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Scrollspy from "react-scrollspy"

export default class Appbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            scrollPos: 0
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll, true);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll() {
        const {scrollPos} = this.state;
        this.setState({
            scrollPos: document.body.getBoundingClientRect().top,
            show: document.body.getBoundingClientRect().top > scrollPos
        });
    }

    render() {
        return (
            <Navbar id="responsive-navbar" expand="lg" variant="dark" fixed="top"
                    collapseOnSelect={true}
                    style={{backgroundColor: "#032539"}}
                    className={"mx-2 " + (this.state.show ? "nav-active" : "nav-hidden")}
            >
                <Navbar.Brand href="#">Blauigris</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">


                    <Nav className="mr-0 ml-auto flex-grow-0">
                        <Scrollspy items={['about', 'interests', 'publications', 'work', 'education', 'contact']}
                                   currentClassName="active"
                                   className={"navbar-nav mr-auto"}
                        >

                            <Nav.Link eventKey="about" as={Link} to="#about">About</Nav.Link>
                            <Nav.Link eventKey="interests" as={Link} to="#interests">Interests</Nav.Link>
                            <Nav.Link eventKey="publications" as={Link} to="#publications">Publications</Nav.Link>
                            <Nav.Link eventKey="work" as={Link} to="#work">Work</Nav.Link>
                            <Nav.Link eventKey="education" as={Link} to="#education">Education</Nav.Link>
                            <Nav.Link eventKey="contact" as={Link} to="#contact">Contact</Nav.Link>
                        </Scrollspy>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        )
    }
}

